import { styleGuideMaterials } from "../../../mocks/inspirations";

export default function SGMaterialsSection() {
  return (
    <section className="py-28 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Text — left */}
          <div>
            <div className="flex items-center gap-3 mb-7">
              <span
                className="text-[#D9CEBC] text-6xl leading-none"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700 }}
              >
                02
              </span>
              <span className="flex-1 h-px bg-[#C8BAA8]" />
            </div>

            <p
              className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Materials &amp; Textures
            </p>

            <h2
              className="text-[#2C2825] text-3xl md:text-4xl leading-snug mb-6"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Natural Materials<br />
              <em>and Textures</em>
            </h2>

            <p
              className="text-[#6B5E53] text-base leading-relaxed mb-10 max-w-sm"
              style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
            >
              Linen, light wood, woven fabrics, and soft finishes that bring calm into everyday spaces.
              Natural materials age beautifully and grow more inviting with time.
            </p>

            {/* Material cards */}
            <div className="grid grid-cols-2 gap-4 mb-10">
              {styleGuideMaterials.map((mat) => (
                <div
                  key={mat.name}
                  className="group overflow-hidden rounded-xl bg-[#EDE6DA] cursor-pointer"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={mat.image}
                      alt={mat.name}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4">
                    <h3
                      className="text-[#2C2825] text-sm mb-1"
                      style={{ fontFamily: "'Playfair Display', serif", fontWeight: 500 }}
                    >
                      {mat.name}
                    </h3>
                    <p
                      className="text-[#8B8378] text-[11px] leading-relaxed"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {mat.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-7 py-3 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Explore Textures
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-line text-[10px]" />
              </span>
            </button>
          </div>

          {/* Image — right */}
          <div className="hidden lg:block">
            <div className="rounded-2xl overflow-hidden aspect-[4/5] bg-[#EDE6DA]">
              <img
                src="https://public.readdy.ai/ai/img_res/ca2e4d16faf7ccb8a0a81cbff7a70b27.jpg"
                alt="Natural materials and textures"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
